/* eslint-disable import/prefer-default-export */
import { UseQueryOptions } from "@tanstack/react-query";
import { getCostRecoverySetting } from "api/services/location";
import { useCustomQuery } from "hooks/useCustomQuery";
import { locationQueryKeys } from "./locationQueryKeys";

export const useGetCostRecoverySetting = (location: string, params: any, options?: UseQueryOptions) =>
  useCustomQuery({
    queryKey: locationQueryKeys.costRecoverySetting(location, params),
    queryFn: () => getCostRecoverySetting(location, { params }).then((res) => res.data),
    ...options,
  });
